import { gql } from '@apollo/client';

import { PageInfoFragmentDoc } from '../../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetWorkflowRulesQueryVariables = GraphQLTypes.Exact<{
  workflowRuleDefinitionId: GraphQLTypes.Scalars['String']['input'];
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  workflowRulesInputObjectFiltersInput?: GraphQLTypes.InputMaybe<GraphQLTypes.WorkflowRulesInputObjectFiltersInput>;
  workflowRulesOutputObjectFiltersInput?: GraphQLTypes.InputMaybe<GraphQLTypes.WorkflowRulesOutputObjectFiltersInput>;
}>;

export type GetWorkflowRulesQueryResult = { __typename?: 'Query' } & {
  workflowRules?: GraphQLTypes.Maybe<
    { __typename?: 'WorkflowRuleConnection' } & Pick<GraphQLTypes.WorkflowRuleConnection, 'totalCount'> & {
        nodes: Array<
          GraphQLTypes.Maybe<
            { __typename?: 'WorkflowRuleType' } & Pick<GraphQLTypes.WorkflowRuleType, 'id'> & {
                ruleDefinition: { __typename?: 'WorkflowRuleDefinitionType' } & Pick<
                  GraphQLTypes.WorkflowRuleDefinitionType,
                  'id'
                > & {
                    ruleInputFields: Array<
                      { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'name'>
                    >;
                    ruleOutputFields: Array<
                      { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'name'>
                    >;
                  };
                ruleInput: { __typename?: 'RuleInputObjectType' } & Pick<
                  GraphQLTypes.RuleInputObjectType,
                  | 'collectionCountry'
                  | 'countryOfDestination'
                  | 'countryOfOrigin'
                  | 'deliveryCountry'
                  | 'destination'
                  | 'incoterms'
                  | 'modeOfTransport'
                  | 'origin'
                  | 'portOfDestination'
                  | 'portOfDestinationCountry'
                  | 'portOfOrigin'
                  | 'portOfOriginCountry'
                  | 'shipmentContext'
                  | 'shipmentType'
                > & {
                    account?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'tradingName'>>;
                    event?: GraphQLTypes.Maybe<
                      Array<
                        GraphQLTypes.Maybe<
                          { __typename?: 'UserDefinedEventType' } & Pick<GraphQLTypes.UserDefinedEventType, 'name'>
                        >
                      >
                    >;
                    supplier?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'tradingName'>>;
                  };
                ruleOutput: { __typename?: 'RuleOutputObjectType' } & {
                  actions?: GraphQLTypes.Maybe<
                    Array<{ __typename?: 'WorkflowAction' } & Pick<GraphQLTypes.WorkflowAction, 'label' | 'path' | 'type'>>
                  >;
                  consignee?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountLocation' } & {
                      label?: GraphQLTypes.Maybe<
                        { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
                      >;
                    }
                  >;
                  consignor?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountLocation' } & {
                      label?: GraphQLTypes.Maybe<
                        { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
                      >;
                    }
                  >;
                  customerOperationsCoordinator?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'firstName' | 'lastName'>
                  >;
                  customsOperationsCoordinator?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'firstName' | 'lastName'>
                  >;
                  destinationOperationsCoordinator?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'firstName' | 'lastName'>
                  >;
                  notifyParties?: GraphQLTypes.Maybe<
                    Array<
                      { __typename?: 'AccountLocation' } & {
                        label?: GraphQLTypes.Maybe<
                          { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
                        >;
                      }
                    >
                  >;
                  originAgent?: GraphQLTypes.Maybe<
                    { __typename?: 'Account' } & {
                      label?: GraphQLTypes.Maybe<
                        { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
                      >;
                    }
                  >;
                  originOperationsCoordinator?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'firstName' | 'lastName'>
                  >;
                  supplierContacts?: GraphQLTypes.Maybe<
                    Array<{ __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'email' | 'firstName' | 'lastName'>>
                  >;
                };
              }
          >
        >;
        pageInfo: { __typename: 'PageInfo' } & Pick<
          GraphQLTypes.PageInfo,
          'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
        >;
      }
  >;
};

export const GetWorkflowRulesDocument = gql`
  query getWorkflowRules(
    $workflowRuleDefinitionId: String!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $workflowRulesInputObjectFiltersInput: WorkflowRulesInputObjectFiltersInput
    $workflowRulesOutputObjectFiltersInput: WorkflowRulesOutputObjectFiltersInput
  ) {
    workflowRules(
      workflowRuleDefinitionId: $workflowRuleDefinitionId
      after: $after
      before: $before
      first: $first
      last: $last
      workflowRulesInputObjectFiltersInput: $workflowRulesInputObjectFiltersInput
      workflowRulesOutputObjectFiltersInput: $workflowRulesOutputObjectFiltersInput
    ) {
      nodes {
        id
        ruleDefinition {
          id
          ruleInputFields {
            name
          }
          ruleOutputFields {
            name
          }
        }
        ruleInput {
          account {
            tradingName
          }
          collectionCountry
          countryOfDestination
          countryOfOrigin
          deliveryCountry
          destination
          event {
            name
          }
          incoterms
          modeOfTransport
          origin
          portOfDestination
          portOfDestinationCountry
          portOfOrigin
          portOfOriginCountry
          shipmentContext
          shipmentType
          supplier {
            tradingName
          }
        }
        ruleOutput {
          actions {
            label
            path
            type
          }
          consignee {
            label {
              long
              short
            }
          }
          consignor {
            label {
              long
              short
            }
          }
          customerOperationsCoordinator {
            firstName
            lastName
          }
          customsOperationsCoordinator {
            firstName
            lastName
          }
          destinationOperationsCoordinator {
            firstName
            lastName
          }
          notifyParties {
            label {
              long
              short
            }
          }
          originAgent {
            label {
              long
              short
            }
          }
          originOperationsCoordinator {
            firstName
            lastName
          }
          supplierContacts {
            email
            firstName
            lastName
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
  ${PageInfoFragmentDoc}
`;
